import React, { useState, useEffect } from 'react';
import { styled } from '../../../stitches.config';
import Slider from "react-slick";
import Box from '../Box'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// icons 
import background from '../../../assets/img/natemat/goodyear/background.jpg'
import logo from '../../../assets/img/natemat/goodyear/logo.jpg'

import img3 from '../../../assets/img/natemat/goodyear/img-1.jpeg';
import img2 from '../../../assets/img/natemat/goodyear/img-2.jpeg';
import img1 from '../../../assets/img/natemat/goodyear/img-3.jpeg';

const config = {
    settings: {
        b1: {
            title: "",
            description: "Opony całoroczne - sprawdź, czy to optymalny wybór dla Ciebie",
            img: img1,
            link: "https://natemat.pl/444304,najlepsze-opony-wielosezonowe-poznaj-goodyear-vector-4seasons-gen-3",
        },
        b2: {
            title: "",
            description: "Jak wybrać solidne opony zimowe dopasowane do portfela i mocy samochodu",
            img: img2,
            link: "https://natemat.pl/444715,najlepsze-opony-zimowe-poznaj-goodyear-ug-performance-i-debica-frigo-hp-2",
        },
        b3: {
            title: "",
            description: "Dlaczego warto powierzyć wymianę opon profesjonalistom? Powody, o których nie myślisz na co dzień",
            img: img3,
            link: "https://natemat.pl/444967,dlaczego-warto-powierzyc-wymiane-opon-profesjonalistom-powody-o-ktorych-nie-myslisz-na-co-dzien",
        },
    }
}

const shuffleCards = (number) => (cards) => {
    const array = Object.keys(cards).map(k => cards[k]);
    let currentIndex = array.length, randomIndex;

    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    const obj = array.reduce((acc, curr, i) => (acc[`b${i + number}`] = curr, acc), {})

    return obj
}

const shuffleCardsAll = shuffleCards(1)

export default props => {
    const [allCards] = useState(config.settings);
    const settings = {
        infinite: true,
        dots: true,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "45px",
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "70px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "50px",
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "20px",
                }
            }
        ]
    };
    return (
        <Section>
            <Wrapper>
                <Logo>
                    <img className="logo" src={logo} />
                </Logo>
                <h1>Opony bez tajemnic – co warto wiedzieć przed zimą</h1>
                <CarouselWrapper>
                    <Slider {...settings}>
                        <Box {...props}
                            id="b1"
                            type="ASpecialGoodyear"
                            settings={allCards.b1}
                        />
                        <Box {...props}
                            id="b2"
                            type="ASpecialGoodyear"
                            settings={allCards.b2}
                        />
                        <Box {...props}
                            id="b3"
                            type="ASpecialGoodyear"
                            settings={allCards.b3}
                        />
                    </Slider>
                </CarouselWrapper>
            </Wrapper>
        </Section>
    );
}

const CustomArrow = styled("div", {
    "img": {
        width: "43px",
        height: "43px",
        margin: "auto",
        position: "absolute",
        top: "-10px",
        left: 0
    }
});

const CarouselWrapper = styled("div", {
    marginBottom: "55px",
    overflow: "visible",
    ".slick-list": {
        marginBottom: "50px",
        "@bp4": {
            marginBottom: "0px",
            padding: "10px 0px"
        }
    },
    ".slick-slide": {
        "& > div": {
            display: "grid",
            placeItems: "center"
        }
    },
    ".slick-dots": {
        bottom: "-35px",
        "li": {
            margin: "0",
            width: "18px",
            height: "9px",
            "&.slick-active": {
                button: {
                    "&:before": {
                        color: "#feda00",
                        "@bp4": {
                            borderRadius: "10px"
                        }
                    }
                }
            },
            "button": {
                width: "9px",
                height: "9px",
                padding: "0",
                "&:before": {
                    width: "9px",
                    height: "9px",
                    fontSize: "9px",
                    lineHeight: "9px",
                    color: "white",
                    opacity: 1,
                    "@bp4": {
                        borderWidth: "0px",
                        borderRadius: "10px"
                    }
                }
            }
        }
    }
});

const Section = styled("div", {
    overflow: "hidden",
    width: "100%",
    backgroundImage: `url("${background}")`,
    backgroundPosition: "left -200px center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    marginTop: "20px",
    marginBottom: "10px",
    paddingBottom: "1px",
    backgroundColor: "#141311",
    "@bp4": {
        backgroundPosition: "center",
        backgroundSize: "cover",
        position: "relative",
        marginTop: "10px"
    },
    "@media only screen and (min-width: 1920px)": {
        backgroundPosition: "left -70px center"
    }
});

const Wrapper = styled("div", {
    width: "100%",
    maxWidth: "1266px",
    margin: "0 auto",
    "@bp4": {
        maxWidth: "990px"
    },
    "h1": {
        fontSize: "30px",
        lineHeight: "38px",
        color: "white",
        textAlign: "center",
        padding: "0 10px",
        fontFamily: '"Montserrat", sans-serif',
        "@bp4": {
            marginBottom: "20px",
            fontSize: "34px",
            lineHeight: "42px"
        }
    }
});

const Logo = styled("div", {
    marginLeft: "calc(50% - 120px)",
    width: "240px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#2e4495",
    ".logo": {
        maxWidth: "200px"
    }
});
